import React from 'react';
import Navbar from './Navbar';

const LayoutsKasir = ({ children }) => {
  return (
    <div className="font-sans min-h-screen leading-normal tracking-normal relative overflow-x-hidden bg-slate-50 dark:bg-[#0b132b] text-slate-800 dark:text-slate-100 transition-colors duration-300">
      <Navbar />
      <div className="w-full pt-16 sm:pt-20 pb-12">
        <div className="w-full px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">{children}</div>
      </div>
    </div>
  );
};

export default LayoutsKasir;
